import { createSelector } from 'reselect'

export const eventOptions = state => state.options.reservationEvent
export const hasError = state => state.reservations.error
export const isPending = state => state.reservations.pending
export const reservation = state => state.modals.reservationEdit.reservation
export const rug = state => state.rugDetail.rug
export const user = state => state.auth.user

export const reservations = createSelector(
  [rug],
  rug => rug.reservations || [],
)
